import { render } from "./InfoRowPatientUpload.vue?vue&type=template&id=616a42ea"
import script from "./InfoRowPatientUpload.vue?vue&type=script&lang=js"
export * from "./InfoRowPatientUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__